
// import  bhk01 from "../assets/images/BHK/2bhk/Modelvilla2BHK_Page_01.jpg" 
import bhk02 from "../assets/images/BHK/2bhk/Modelvilla2BHK_Page_02.jpg" 
import bhk03 from "../assets/images/BHK/2bhk/Modelvilla2BHK_Page_03.jpg" 
import bhk04 from "../assets/images/BHK/2bhk/Modelvilla2BHK_Page_04.jpg" 
import bhk05 from "../assets/images/BHK/2bhk/Modelvilla2BHK_Page_05.jpg" 
import bhk06 from "../assets/images/BHK/2bhk/Modelvilla2BHK_Page_06.jpg" 
import bhk07 from "../assets/images/BHK/2bhk/Modelvilla2BHK_Page_07.jpg" 
import bhk08 from "../assets/images/BHK/2bhk/Modelvilla2BHK_Page_08.jpg" 
import bhk09 from "../assets/images/BHK/2bhk/Modelvilla2BHK_Page_09.jpg" 
import bhk10 from "../assets/images/BHK/2bhk/Modelvilla2BHK_Page_10.jpg"


// import bhk21 from "../assets/images/BHK/3bhk/Modelvilla3BHK_Page_01.jpg" 
import bhk22 from "../assets/images/BHK/3bhk/Modelvilla3BHK_Page_02.jpg" 
import bhk23 from "../assets/images/BHK/3bhk/Modelvilla3BHK_Page_03.jpg" 
import bhk24 from "../assets/images/BHK/3bhk/Modelvilla3BHK_Page_04.jpg" 
import bhk25 from "../assets/images/BHK/3bhk/Modelvilla3BHK_Page_05.jpg" 
import bhk26 from "../assets/images/BHK/3bhk/Modelvilla3BHK_Page_06.jpg" 
import bhk27 from "../assets/images/BHK/3bhk/Modelvilla3BHK_Page_07.jpg" 
import bhk28 from "../assets/images/BHK/3bhk/Modelvilla3BHK_Page_08.jpg" 
import bhk29 from "../assets/images/BHK/3bhk/Modelvilla3BHK_Page_09.jpg" 
import bhk30 from "../assets/images/BHK/3bhk/Modelvilla3BHK_Page_10.jpg"

export const galleries ={
     twoBhk:  [
  //  { src: bhk01, title: "Model Villa 2BHK"},
   { src: bhk02, title: "Model Villa 2BHK"},
   { src: bhk03, title: "Model Villa 2BHK"},
   { src: bhk04, title: "Model Villa 2BHK"},
   { src: bhk05, title: "Model Villa 2BHK"},
   { src: bhk06, title: "Model Villa 2BHK"},
   { src: bhk07, title: "Model Villa 2BHK"},
   { src: bhk08, title: "Model Villa 2BHK"},
   { src: bhk09, title: "Model Villa 2BHK"},
   { src: bhk10, title: "Model Villa 2BHK"},
  ],
  threeBhk: [
    // { src: bhk21, title: "Model Villa 3BHK"},
    { src: bhk22, title: "Model Villa 3BHK"},
    { src: bhk23, title: "Model Villa 3BHK"},
    { src: bhk24, title: "Model Villa 3BHK"},
    { src: bhk25, title: "Model Villa 3BHK"},
    { src: bhk26, title: "Model Villa 3BHK"},
    { src: bhk27, title: "Model Villa 3BHK"},
    { src: bhk28, title: "Model Villa 3BHK"},
    { src: bhk29, title: "Model Villa 3BHK"},
    { src: bhk30, title: "Model Villa 3BHK"},
  ]
}